
import { defineComponent } from 'vue';
import PasswordInput from '@/components/atoms/PasswordInput.vue';
import Button from '@/components/atoms/Button.vue';
import Logo from '@/components/atoms/Logo.vue';
import { forgotPasswordSubmit } from '@/service/cognitoService';
import { mapActions, mapGetters } from 'vuex';
import { AppStatus } from '@/model/status';

export default defineComponent({
  name: 'ForgotPasswordConfirm',
  components: {
    PasswordInput,
    Button,
    Logo
  },
  data: () => ({
    password: '',
    confirmPassword: '',
    resetPasswordSuccess: false,
    isValidPassword: false
  }),
  methods: {
    ...mapActions(['setMyEmail', 'setAppStatus', 'startLoading', 'endLoading']),

    async handleResetPassword () {
      try {
        this.startLoading();
        await forgotPasswordSubmit(this.emailToResetPassword, this.codeToResetPassword, this.password);
        this.setAppStatus(AppStatus.ResetPasswordSuccess);
      } catch (error: any) {
        this.setAppStatus(AppStatus.ResetPasswordError);
      } finally {
        this.endLoading();
        this.setMyEmail(this.emailToResetPassword);
        this.pushLogin();
      }
    },
    pushLogin () {
      this.$router.push({
        path: 'login',
        query: {
          client_id: this.$route.query.client_id,
          redirect_uri: this.$route.query.redirect_uri,
          language: this.$route.query.language
        }
      });
    },
    updatePasswordStatus (isValid: boolean) {
      this.isValidPassword = isValid;
    }
  },
  computed: {
    ...mapGetters([
      'global',
      'resetPasswordMessages',
      'emailToResetPassword',
      'codeToResetPassword'
    ]),
    checkPasswordsMatch (): boolean {
      return this.password !== this.confirmPassword;
    },
    confirmPasswordErrorMessage (): string {
      if (!this.checkPasswordsMatch) {
        return '';
      }

      return this.confirmPassword
        ? this.$t('message.accessibility.passwords_not_match')
        : this.$t('message.accessibility.confirm_password_required');
    },
    passwordsMatch (): boolean {
      return this.password === this.confirmPassword;
    }
  }
});
